import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const HowItWorks = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="how-it-works-title"
      aria-describedby="how-it-works-description"
    >
      <Box className="modal-box" sx={{ 
        position: 'absolute', 
        top: '50%', 
        left: '50%', 
        transform: 'translate(-50%, -50%)', 
        bgcolor: 'background.paper', 
        boxShadow: 24, 
        color: 'var(--text-color-black)', // Ensure font color is black in dark mode
        p: 4 
      }}>
        <Typography id="how-it-works-title" variant="h6" component="h2">
          How It Works
        </Typography>
        <Typography id="how-it-works-description" sx={{ mt: 2 }}>
          This web application allows you to manage and analyze your cryptocurrency portfolio. Here’s how it works:
        </Typography>
        <ul>
          <li><strong>Add Tokens:</strong> Use the "Add Token" button to search for and add cryptocurrencies to your portfolio.</li>
          
          <li><strong>What If Analysis:</strong> Use the "What If" button to simulate potential investment outcomes based on future price scenarios.</li>
         
        </ul>
        <Typography sx={{ mt: 2 }}>
          <strong>Purpose and Benefits:</strong> This app helps you keep track of your cryptocurrency investments, analyze their performance, and make informed decisions. It provides a comprehensive overview of your portfolio, allowing you to visualize your investments and simulate future scenarios.
        </Typography>
        <Button onClick={onClose} color="primary" sx={{ mt: 2 }}>Lets go!</Button>
      </Box>
    </Modal>
  );
};

export default HowItWorks;
